export default __webpack_public_path__ + "static/media/Button_carousel_right.10a2ee36.webp";